export default __webpack_public_path__ + "static/media/wallet-icon.a59dcbe8.svg";